import api from '../../plugins/api';

// GET /api/crm/onboarding â ÑÑÐ¾ ÑÐ¾ÑÑÑÐ´Ð½Ð¸Ðº ÑÐ¶Ðµ Ð¿ÑÐ¾ÑÑÐ» Ð² Ð¾Ð±ÑÑÐµÐ½Ð¸Ð¸.
const getOnboarding = () => {
  return api.get('/api/crm/onboarding');
};

export default getOnboarding;
